import { useGLTF, Text, Float } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { CuboidCollider, RigidBody } from "@react-three/rapier";
import { useMemo, useRef, useState } from "react";
import * as THREE from "three";

//Colormangement pour rendre les couleur neutre
THREE.ColorManagement.legacyMode = false;

//Création d'une géometry pour l'optimisation
const boxGeometry = new THREE.BoxGeometry(1, 1, 1);

//Materiaux pour les sols pour optimisation
const floor1Material = new THREE.MeshStandardMaterial({ color: '#111111', metalness: 0, roughness: 0 })
const floor2Material = new THREE.MeshStandardMaterial({ color: '#222222', metalness: 0, roughness: 0 })
const obstacleMaterial = new THREE.MeshStandardMaterial({ color: '#ff0000', metalness: 0, roughness: 1 })
const wallMaterial = new THREE.MeshStandardMaterial({ color: '#887777', metalness: 0, roughness: 0 })

//Creation d'un floordedemarage
export function BlockStart({ position = [0, 0, 0] }) {
  return (
    <group position={position}>
      <Float floatIntensity={0.25} rotationIntensity={0.25}>
        <Text
          font="./bebas-neue-v9-latin-regular.woff"
          scale={0.4}
          maxWidth={0.25}
          lineHeight={0.75}
          textAlign="center"
          position={[0.75, 0.65, 0]}
          rotation-y={-0.25}
        >
          MArble Race
          <meshBasicMaterial toneMapped={false} />
        </Text>
      </Float>
      <mesh
        geometry={boxGeometry}
        material={floor1Material}
        position={[0, -0.1, 0]}
        scale={[4, 0.2, 4]}
        receiveShadow
      ></mesh>
    </group>
  );
}

export function BlockSpinner({ position = [0, 0, 0] }) {
  const obstacle = useRef();
  const [speed] = useState(
    () => (Math.random() + 0.2) * (Math.random() < 0.5 ? -1 : 1)
  );
  useFrame((state) => {
    const time = state.clock.getElapsedTime();

    const rotation = new THREE.Quaternion();
    rotation.setFromEuler(new THREE.Euler(0, time * speed, 0));
    obstacle.current.setNextKinematicRotation(rotation);
  });
  return (
    <group position={position}>
      <mesh
        geometry={boxGeometry}
        material={floor2Material}
        position={[0, -0.1, 0]}
        scale={[4, 0.2, 4]}
        receiveShadow
      ></mesh>

      <RigidBody
        ref={obstacle}
        type="kinematicPosition"
        position={[0, 0.3, 0]}
        restitution={0.2}
        friction={0}
      >
        <mesh
          geometry={boxGeometry}
          material={obstacleMaterial}
          scale={[3.5, 0.3, 0.3]}
          castShadow
          receiveShadow
        />
      </RigidBody>
    </group>
  );
}

export function BlockLimbo({ position = [0, 0, 0] }) {
  const obstacle = useRef();
  const [TimeOffset] = useState(() => {
    return Math.random() * Math.PI * 2;
  });
  useFrame((state) => {
    const time = state.clock.getElapsedTime();
    const tranlationY = Math.sin(time + TimeOffset) + 1.15;
    obstacle.current.setNextKinematicTranslation({
      x: position[0],
      y: position[0] + tranlationY,
      z: position[2],
    });
  });
  return (
    <group position={position}>
      <mesh
        geometry={boxGeometry}
        material={floor2Material}
        position={[0, -0.1, 0]}
        scale={[4, 0.2, 4]}
        receiveShadow
      ></mesh>

      <RigidBody
        ref={obstacle}
        type="kinematicPosition"
        position={[0, 0.3, 0]}
        restitution={0.2}
        friction={0}
      >
        <mesh
          geometry={boxGeometry}
          material={obstacleMaterial}
          scale={[3.5, 0.3, 0.3]}
          castShadow
          receiveShadow
        />
      </RigidBody>
    </group>
  );
}

export function BlockAxe({ position = [0, 0, 0] }) {
  const obstacle = useRef();
  const [TimeOffset] = useState(() => {
    return Math.random() * Math.PI * 2;
  });
  useFrame((state) => {
    const time = state.clock.getElapsedTime();
    const x = Math.sin(time + TimeOffset) * 1.25;
    obstacle.current.setNextKinematicTranslation({
      x: position[0] + x,
      y: position[1] + 0.75,
      z: position[2],
    });
  });
  return (
    <group position={position}>
      <mesh
        geometry={boxGeometry}
        material={floor2Material}
        position={[0, -0.1, 0]}
        scale={[4, 0.2, 4]}
        receiveShadow
      ></mesh>

      <RigidBody
        ref={obstacle}
        type="kinematicPosition"
        position={[0, 0.3, 0]}
        restitution={0.2}
        friction={0}
      >
        <mesh
          geometry={boxGeometry}
          material={obstacleMaterial}
          scale={[1.5, 1.5, 0.3]}
          castShadow
          receiveShadow
        />
      </RigidBody>
    </group>
  );
}

export function BlockEnd({ position = [0, 0, 0] }) {
  const hamburger = useGLTF("/hamburger.glb");

  hamburger.scene.children.forEach((mesh) => {
    mesh.castShadow = true;
    mesh.receiveShadow = true;
  });
  console.log(hamburger);
  return (
    <group position={position}>
      <Text
        font="./bebas-neue-v9-latin-regular.woff"
        scale={1}
        position={[0, 2.25, 2]}
      >
        FINISH
        <meshBasicMaterial toneMapped={false} />
      </Text>
      <mesh
        geometry={boxGeometry}
        material={floor1Material}
        position={[0, 0, 0]}
        scale={[4, 0.2, 4]}
        receiveShadow
      />
      <RigidBody
        type="fixed"
        colliders="hull"
        position={[0, 0.25, 0]}
        restitution={0.2}
        friction={0}
      >
        <primitive object={hamburger.scene} scale={0.2} />
      </RigidBody>
    </group>
  );
}

// export  function BlockEnd(props) {
//   const { nodes, materials } = useGLTF("/FlatLand.glb");
//   return (
//     <RigidBody type="fixed" colliders='trimesh'>
//     <group {...props} dispose={null}>
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.Rock1.geometry}
//         material={materials["Material.006"]}
//         position={[5.61, -1.23, 3]}
//         scale={0.36}
//       />
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.Rock2.geometry}
//         material={materials["Material.006"]}
//         position={[4.41, -1.59, 2.61]}
//         scale={0.36}
//       />
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.Rock3.geometry}
//         material={materials["Material.006"]}
//         position={[3.44, -1.81, 2.33]}
//         scale={0.41}
//       />
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.Rock4.geometry}
//         material={materials["Material.006"]}
//         position={[7.07, -1.48, -0.07]}
//         rotation={[0.53, 0.22, -1.08]}
//         scale={0.41}
//       />
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.Rock5.geometry}
//         material={materials["Material.006"]}
//         position={[5.33, -0.14, -4.76]}
//         rotation={[0.57, -0.18, 1.2]}
//         scale={0.27}
//       />
//       <group position={[-4.23, 0.01, -1.8]} scale={0.2}>
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube006.geometry}
//           material={materials["Tronc.001"]}
//         />
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube006_1.geometry}
//           material={materials["Material.004"]}
//         />
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube006_2.geometry}
//           material={materials.Feuille}
//         />
//       </group>
//       <group
//         position={[-3.37, 0.71, -5.17]}
//         rotation={[-0.03, -0.94, 0]}
//         scale={0.2}
//       >
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube001.geometry}
//           material={materials["Tronc.001"]}
//         />
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube001_1.geometry}
//           material={materials["Material.004"]}
//         />
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube001_2.geometry}
//           material={materials.Feuille}
//         />
//       </group>
//       <group
//         position={[-0.93, -0.41, 2.07]}
//         rotation={[-0.02, -0.14, 0.02]}
//         scale={0.28}
//       >
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube002.geometry}
//           material={materials["Tronc.001"]}
//         />
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube002_1.geometry}
//           material={materials["Material.004"]}
//         />
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube002_2.geometry}
//           material={materials.Feuille}
//         />
//       </group>
//       <group
//         position={[6, 0.06, 2.92]}
//         rotation={[-3.12, 0.51, -3.13]}
//         scale={0.22}
//       >
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube003.geometry}
//           material={materials["Tronc.001"]}
//         />
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube003_1.geometry}
//           material={materials["Material.004"]}
//         />
//         <mesh
//           castShadow
//           receiveShadow
//           geometry={nodes.Cube003_2.geometry}
//           material={materials.Feuille}
//         />
//       </group>
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.Eau.geometry}
//         material={materials.Material}
//         position={[-1.61, -0.51, 1.28]}
//         rotation={[0, 0.67, 0]}
//         scale={11.04}
//       />
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.Ile.geometry}
//         material={materials["Material.002"]}
//         position={[0.01, 0, -0.02]}
//         scale={[10, 10.01, 10]}
//       />
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.Ile001.geometry}
//         material={materials.MaterialWhite}
//         scale={[10, 10.01, 10]}
//       />
//       <mesh
//         castShadow
//         receiveShadow
//         geometry={nodes.Ile002.geometry}
//         material={materials.Verdure}
//         position={[0.01, 0, -0.02]}
//         scale={[10, 10.01, 10]}
//       />
//     </group>
//     </RigidBody>
//   );
// }

// useGLTF.preload("/FlatLand.glb");

function Bounds({ length = 1 }) {
  return (
    <>
      <RigidBody type="fixed" restitution={0.2} friction={0}>
        <mesh
          position={[2.15, 0.75, -(length * 2) + 2]}
          geometry={boxGeometry}
          material={wallMaterial}
          scale={[0.3, 1.5, 4 * length]}
          castShadow
        />
        <mesh
          position={[-2.15, 0.75, -(length * 2) + 2]}
          geometry={boxGeometry}
          material={wallMaterial}
          scale={[0.3, 1.5, 4 * length]}
          receiveShadow
        />
        <mesh
          position={[0, 0.75, -(length * 4) + 2]}
          geometry={boxGeometry}
          material={wallMaterial}
          scale={[4, 1.5, 0.3]}
          receiveShadow
        />

        <CuboidCollider
          args={[2, 0.1, 2 * length]}
          position={[0, -0.1, -(length * 2) + 2]}
          restitution={0.2}
          friction={1}
        />
      </RigidBody>
    </>
  );
}

export function Level({
  count = 10,
  types = [BlockSpinner, BlockAxe, BlockLimbo],
  seed = 0,
}) {
  const blocks = useMemo(() => {
    const blocks = [];

    for (let i = 0; i < count; i++) {
      const type = types[Math.floor(Math.random() * types.length)];
      blocks.push(type);
    }
    return blocks;
  }, [count, types, seed]);

  return (
    <>
      <BlockStart position={[0, 0, 0]} />
      {blocks.map((Block, index) => (
        <Block key={index} position={[0, 0, -(index + 1) * 4]} />
      ))}
      <BlockEnd position={[0, 0, -(count + 1) * 4]} />

      <Bounds length={count + 2} />
    </>
  );
}
